<div class="page-content page-fill">
  <div class="card mb-3">
    <div class="card-body">
      <h2>
        <strong>School Year: {{ schoolYear }}</strong>
      </h2>
    </div>
  </div>
  <div class="grid-fill">
    <dx-data-grid #dataGrid [dataSource]="people" keyExpr="id" [wordWrapEnabled]="true" [rowAlternationEnabled]="false" (onToolbarPreparing)="onToolbarPreparing($event)">
      <dxi-column dataField="firstName" [width]="135" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="preferredName" [width]="125"></dxi-column>
      <dxi-column dataField="lastName" [width]="125" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="birthDate" [width]="100" dataType="date" [format]="{ type: 'shortDate' }"></dxi-column>
      <dxi-column dataField="graduationDate" caption="Est. Graduation Date" [width]="200" dataType="date"></dxi-column>
      <dxi-column dataField="gradeId" caption="Grade" [width]="100"></dxi-column>
      <dxi-column dataField="gradeName" caption="Grade" [width]="100"></dxi-column>
      <dxi-column dataField="school" caption="School" [width]="180"></dxi-column>
      <dxi-column dataField="gCEOF" caption="GCEOF School" editorType="dxCheckBox" [width]="120"></dxi-column>
      <dxi-column width="100"></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        @if (peopleAdmin) {
          <a [routerLink]="" (click)="openPerson(cell.data)">{{ cell.value || '(blank)' }}</a>
        }
        @if (!peopleAdmin) {
          <div>{{ cell.value || '(blank)' }}</div>
        }
      </div>

      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="sundaySchoolGrid"></dxo-state-storing>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-export [enabled]="true"></dxo-export>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button (click)="updateGrade()" class="btn btn-primary" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Update Class</button>
        <button (click)="updateSchool()" class="btn btn-primary ms-2" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Update School</button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (people) {
          <span class="ms-3"
            ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
            >
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
